var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5448 24.1905L19.307 31.614C19.8232 32.1079 20.0594 32.8186 19.9369 33.5144L18.1063 44L27.6991 39.046C28.3356 38.7153 29.0989 38.7153 29.7354 39.046L39.3282 44L37.4976 33.5144C37.3773 32.8186 37.6113 32.1079 38.1275 31.614L45.8897 24.1905L35.1595 22.6509C34.4487 22.5478 33.8319 22.1097 33.5148 21.4762L28.7183 11.9355L23.9197 21.4762C23.6026 22.1097 22.988 22.5478 22.275 22.6509L11.5448 24.1905ZM42.2229 50.8702C41.8754 50.8702 41.5257 50.7872 41.2044 50.619L28.7183 44.0562L16.2278 50.619C15.4935 51.0078 14.5996 50.9422 13.9243 50.453C13.2533 49.9638 12.9167 49.1361 13.0566 48.3171L15.441 34.4248L5.3372 24.5904C4.74054 24.0094 4.52635 23.1424 4.78206 22.3518C5.03996 21.5612 5.72404 20.9846 6.54581 20.8645L20.5137 18.8247L26.7579 6.18162C27.4944 4.69215 29.9401 4.69215 30.6766 6.18162L36.9207 18.8247L50.8887 20.8645C51.7126 20.9846 52.3967 21.5612 52.6524 22.3518C52.9081 23.1424 52.6939 24.0094 52.0973 24.5904L41.9934 34.4248L44.3779 48.3171C44.5178 49.1361 44.1812 49.9638 43.508 50.453C43.1256 50.7304 42.6753 50.8702 42.2229 50.8702Z",
    fill: "#F29469"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4c8f359fa8cdfed8f9e117afaa961fb6.svg";
export { ForwardRef as ReactComponent };